module.exports = __webpack_public_path__ + "img/AU-2.jpg-768x402.20443a8b.webp";